'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsGenerator = require('./utils/propsGenerator');

var _propsGenerator2 = _interopRequireDefault(_propsGenerator);

var _filterMountOrUnmount2 = require('./utils/filterMountOrUnmount');

var _filterMountOrUnmount3 = _interopRequireDefault(_filterMountOrUnmount2);

var _mapChildren = require('./utils/mapChildren');

var _mapChildren2 = _interopRequireDefault(_mapChildren);

var _setDelayState = require('./utils/setDelayState');

var _setDelayState2 = _interopRequireDefault(_setDelayState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = exports.defaultState = {
  willEnd: false,
  willStart: false,
  willComplete: false,
  willEnter: false,
  willLeave: false,
  played: false,
  childrenStoreInState: []
};

var timeDelayForChildren = 0.001;

var Animate = function (_React$Component) {
  _inherits(Animate, _React$Component);

  function Animate(props) {
    _classCallCheck(this, Animate);

    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _this.setCurrentChildrenToState = function () {
      _this.setState({
        childrenStoreInState: _this.props.children
      });
    };

    _this.delayTimeout = null;
    _this.completeTimeout = null;
    _this.leaveTimeout = null;
    _this.enterTimeout = null;

    _this.state = _extends({}, defaultState, props.children ? { childrenStoreInState: props.children } : null);
    return _this;
  }

  _createClass(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setDelayAndOnComplete(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var startAnimation = nextProps.startAnimation,
          children = nextProps.children,
          animateOnAddRemove = nextProps.animateOnAddRemove,
          reverseDelaySeconds = nextProps.reverseDelaySeconds;

      var toggledAnimation = startAnimation !== this.props.startAnimation;

      this.setState(_extends({}, toggledAnimation ? _extends(_extends({}, defaultState)) : null, {
        childrenStoreInState: children,
        played: toggledAnimation
      }));
      if (animateOnAddRemove) this.setChildrenState(nextProps);
      this.setDelayAndOnComplete(nextProps, toggledAnimation && !startAnimation && !!reverseDelaySeconds);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_ref, _ref2) {
      var startStyle = _ref.startStyle,
          endStyle = _ref.endStyle,
          startAnimation = _ref.startAnimation,
          children = _ref.children,
          forceUpdate = _ref.forceUpdate;
      var willEnd = _ref2.willEnd,
          willStart = _ref2.willStart,
          willComplete = _ref2.willComplete,
          willLeave = _ref2.willLeave,
          willEnter = _ref2.willEnter;

      // only situation that should trigger a re-render
      return (
        // object compare can be enahnced, but try to keep it simple here
        JSON.stringify(startStyle) !== JSON.stringify(this.props.startStyle) || JSON.stringify(endStyle) !== JSON.stringify(this.props.endStyle) || startAnimation !== this.props.startAnimation || children !== this.props.children || willEnd !== this.state.willEnd || willStart !== this.state.willStart || willComplete !== this.state.willComplete || willLeave !== this.state.willLeave || willEnter !== this.state.willEnter || !!forceUpdate
      );
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      var _props$onError = this.props.onError,
          onError = _props$onError === undefined ? false : _props$onError;

      if (onError) onError(error, info);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.delayTimeout && clearTimeout(this.delayTimeout);
      this.completeTimeout && clearTimeout(this.completeTimeout);
      this.leaveTimeout && clearTimeout(this.leaveTimeout);
      this.enterTimeout && clearTimeout(this.enterTimeout);
      this.delayTimeout = undefined;
      this.completeTimeout = undefined;
      this.leaveTimeout = undefined;
      this.enterTimeout = undefined;
    }
  }, {
    key: 'setDelayAndOnComplete',
    value: function setDelayAndOnComplete(_ref3) {
      var delaySeconds = _ref3.delaySeconds,
          startAnimation = _ref3.startAnimation,
          onCompleteStyle = _ref3.onCompleteStyle,
          durationSeconds = _ref3.durationSeconds,
          onComplete = _ref3.onComplete,
          reverseDelaySeconds = _ref3.reverseDelaySeconds;
      var isReverseWithDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // delay animation
      this.delayTimeout && clearTimeout(this.delayTimeout);

      if (delaySeconds && startAnimation) {
        this.delayTimeout = _setDelayState2.default.call(this, delaySeconds, 'willEnd');
      } else if (isReverseWithDelay) {
        // reverse animation
        this.delayTimeout = _setDelayState2.default.call(this, reverseDelaySeconds, 'willStart');
      }

      if (!onComplete && !onCompleteStyle || !startAnimation) return;

      this.completeTimeout && clearTimeout(this.completeTimeout);
      this.completeTimeout = _setDelayState2.default.call(this, parseFloat(delaySeconds) || parseFloat(durationSeconds) || 0, 'willComplete', onComplete);
    }
  }, {
    key: 'setChildrenState',
    value: function setChildrenState(nextProps) {
      var childrenStoreInState = this.state.childrenStoreInState;
      var children = nextProps.children,
          startAnimation = nextProps.startAnimation,
          durationSeconds = nextProps.durationSeconds;


      if (!Array.isArray(childrenStoreInState) || !Array.isArray(children) || !startAnimation) {
        return;
      }

      if (childrenStoreInState.length !== children.length) {
        var _filterMountOrUnmount = (0, _filterMountOrUnmount3.default)(childrenStoreInState, children),
            mappedChildren = _filterMountOrUnmount.mappedChildren,
            childrenWillUnmount = _filterMountOrUnmount.childrenWillUnmount,
            childrenWillMount = _filterMountOrUnmount.childrenWillMount;

        if (childrenWillUnmount && startAnimation) {
          this.leaveTimeout && clearTimeout(this.leaveTimeout);
          this.leaveTimeout = _setDelayState2.default.call(this, durationSeconds, 'willLeave', this.setCurrentChildrenToState);
        }

        this.setState({
          willEnter: false,
          willLeave: false,
          childrenStoreInState: mappedChildren
        });

        if (childrenWillMount && startAnimation) {
          this.enterTimeout && clearTimeout(this.enterTimeout);
          this.enterTimeout = _setDelayState2.default.call(this, timeDelayForChildren, 'willEnter', this.setCurrentChildrenToState);
        }
      } else if (!startAnimation) {
        this.enterTimeout && clearTimeout(this.enterTimeout);
        this.enterTimeout = _setDelayState2.default.call(this, timeDelayForChildren, 'willEnter', this.setCurrentChildrenToState);

        this.setState({
          childrenStoreInState: childrenStoreInState
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          animateOnAddRemove = _props.animateOnAddRemove,
          render = _props.render;

      var tagName = tag || 'div';
      var componentProps = (0, _propsGenerator2.default)(this.props, this.state);
      var haveChildToAnimate = Array.isArray(children) && animateOnAddRemove;

      if (render && !haveChildToAnimate) {
        return render(componentProps);
      }
      return _react2.default.createElement(tagName, componentProps, haveChildToAnimate ? (0, _mapChildren2.default)(this.props, this.state) : children);
    }
  }]);

  return Animate;
}(_react2.default.Component);

Animate.displayName = 'ReactSimpleAnimate';
Animate.defaultProps = {
  startStyle: {},
  onCompleteStyle: undefined,
  durationSeconds: 0.3,
  delaySeconds: 0,
  children: null,
  reverseDelaySeconds: 0,
  easeType: 'linear',
  forceUpdate: false,
  tag: 'div',
  onComplete: undefined,
  onError: undefined,
  className: undefined,
  transition: '',
  refCallback: undefined
};
exports.default = Animate;